import {ActionHandlerBase} from "../action-handler-base";
import {IOpenCashierActionPayload} from "@sparkware/uc-sdk-core";
import {CIPropRead} from "../../../../../utils/case-insensitive-property-reader";

export class OpenCashierActionHandler extends ActionHandlerBase<IOpenCashierActionPayload> {
    async handle(payload: IOpenCashierActionPayload): Promise<void> {
        await this.services.cashier.openCashier({
            sessionType: CIPropRead.getNumericProperty('sessionType', payload.launchInfo?.appSpecificParameters)
                         ||  CIPropRead.getNumericProperty('TabId', payload.launchInfo?.appSpecificParameters),
            channel: payload.launchInfo?.channel,
            PromCode: CIPropRead.getStringProperty('PromoCode', payload.launchInfo?.appSpecificParameters)
        });
    }

}